var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx } from "react/jsx-runtime";
import "../CommandBar/index.js";
import { CommandBar } from "../CommandBar/CommandBar.js";
const SearchCommandBar = (props) => {
  return /* @__PURE__ */ jsx(
    CommandBar,
    __spreadValues({
      styles: {
        root: {
          marginBottom: "0",
          backgroundColor: "#f4f4f4",
          height: "40px",
          selectors: {
            ".ms-OverflowSet-item:first-child": {
              flex: 1
            },
            ".ms-OverflowSet-item:first-child > div": {
              width: "100%"
            }
          }
        }
      }
    }, props)
  );
};
export {
  SearchCommandBar
};
//# sourceMappingURL=SearchCommandBar.js.map
